import { motion, useScroll, useSpring } from "framer-motion";

/**
 * Editorial scroll progress ribbon — 2px, ivory→emerald gradient.
 * Sits below the fixed navbar and animates on real scroll.
 */
export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 140, damping: 22, mass: 0.4 });
  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-[2px] z-[60] origin-left pointer-events-none"
      style={{
        scaleX,
        background: "linear-gradient(90deg, #1E5C8A 0%, #89E877 100%)",
      }}
      data-testid="scroll-progress"
    />
  );
}
